import React from "react";
import Section from "../ui/Section/Section";
import { Grid } from "../ui/Grid/Grid";
import Card, {
    CardBody,
    CardTitle,
    CardUnit,
    CardValue,
} from "../ui/Card/Card";
import ChartCard from "../ui/Card/ChartCard";
import GaugeStat from "../ui/GaugeStat/GaugeStat";
import SplitBar from "../ui/SplitBar/SplitBar";
import MiniMetric from "../ui/MiniMetric/MiniMetric";
import SectionSkeleton from "../ui/SectionSkeleton/SectionSkeleton";
import { KPI, SECTIONS } from "../../constants";
import { fmt1, fmtN } from "../../functions/format";
import { CHART_COLORS } from "../../styles/theme";

const { id, title } = SECTIONS.taches;

const SKELETON_ROWS = [
    { cols: 3, cards: [2, 3, 3] },
    { cols: 3, cards: [3, 3, 2] },
];

/** Carte "grande valeur" centrée verticalement */
const BigValueCard = ({ label, value, unit }) => (
    <Card column>
        <CardTitle>{label}</CardTitle>
        <CardBody>
            <CardValue>
                {value}
                <CardUnit>{unit}</CardUnit>
            </CardValue>
        </CardBody>
    </Card>
);

const TachesSection = ({ data, isLoading }) => {
    if (isLoading && !data) {
        return (
            <Section id={id} title={title}>
                <SectionSkeleton rows={SKELETON_ROWS} />
            </Section>
        );
    }

    if (!data) return null;

    return (
        <Section id={id} title={title}>
            <Grid cols={3}>
                <BigValueCard
                    label={KPI.absences_jour.label}
                    value={fmtN(data.absencesJour)}
                    unit={KPI.absences_jour.unit}
                />

                <ChartCard title="Soldes de vacances" fill>
                    <SplitBar
                        left={{
                            label: "Consommé",
                            value: `${fmt1(data.vacancesAllouees)} j`,
                            pct: data.vacancesAllouees,
                            tip: `Consommé : ${fmt1(
                                data.vacancesConsommees
                            )} j sur ${fmt1(data.vacancesDisponibles)} j`,
                        }}
                        right={{
                            label: "Disponible",
                            value: `${fmt1(data.vacancesDisponibles)} j`,
                            tip: `Disponible : ${fmt1(
                                data.vacancesDisponibles
                            )} j`,
                        }}
                    />
                </ChartCard>

                <ChartCard title="Mouvements en cours">
                    <MiniMetric
                        label="Onboarding"
                        value={`${fmtN(data.onboardingsEnCours)} collab.`}
                    />
                    <MiniMetric
                        label="Offboarding"
                        value={`${fmtN(data.offboardingsEnCours)} collab.`}
                    />
                </ChartCard>
            </Grid>

            <Grid cols={3} $mt>
                <ChartCard title="Validation feuilles de temps">
                    <GaugeStat
                        pct={data.validationFeuilles}
                        unit="%"
                        sub="validées"
                        value={fmt1(data.validationFeuilles)}
                        tip={`${fmt1(
                            data.validationFeuilles
                        )} % des feuilles validées`}
                    />
                </ChartCard>

                <ChartCard title="Envoi feuilles de temps">
                    <GaugeStat
                        pct={data.envoiFeuilles}
                        color={CHART_COLORS.blue}
                        unit="%"
                        sub="envoyées"
                        value={fmt1(data.envoiFeuilles)}
                        tip={`${fmt1(
                            data.envoiFeuilles
                        )} % des feuilles envoyées`}
                    />
                </ChartCard>

                <BigValueCard
                    label="Tâches à échéance"
                    value={fmtN(data.tachesEchues)}
                    unit="tâches"
                />
            </Grid>
        </Section>
    );
};

export default TachesSection;
